// extracted by mini-css-extract-plugin
export var editInput = "_f9-0";
export var editInputCompact = "_f9-2";
export var editInputLarge = "_f9-1";
export var editInputSmall = "_f9-3";